import React from 'react'
import PropTypes from 'prop-types'
import AutoComplete from 'Components/AutoComplete'
import SvgIcon from 'Components/SvgIcon'
import { _CloseIcon, _Container } from './styles'

const BuildingAutoComplete = (
  {
    typingStart,
    results,
    loadAutoComplete,
    handleItemSelect,
    placeHolder,
    closeSearch = () => {},
    sectionTitle = 'Building',
    isFetching = false,
    autoFocus,
    onBlur,
    className = '',
    showClose,
    onCloseClick = () => {},
  }) =>
  (
    <_Container data-test-id={'buildingAutoComplete'} className={className}>
      <AutoComplete
        multiSection
        resetInputOnSelect
        result={results ? { [sectionTitle]: results } : null}
        isFetching={isFetching}
        placeHolder={placeHolder}
        loadAutoComplete={loadAutoComplete}
        typingStart={typingStart}
        closeSearch={closeSearch}
        onSuggestionSelect={(e) => {
          handleItemSelect(e)
          loadAutoComplete('')
        }}
        autoFocus={autoFocus}
        onBlur={onBlur}
      />
      {
        showClose && (
          <_CloseIcon onClick={onCloseClick}>
            <SvgIcon name={'#icon-close'} width={12} height={12} />
          </_CloseIcon>
        )
      }
    </_Container>
  )

BuildingAutoComplete.propTypes = {
  typingStart: PropTypes.func,
  results: PropTypes.arrayOf(PropTypes.shape({})),
  loadAutoComplete: PropTypes.func,
  handleItemSelect: PropTypes.func,
  placeHolder: PropTypes.string,
  closeSearch: PropTypes.func,
  sectionTitle: PropTypes.string,
  className: PropTypes.string,
  isFetching: PropTypes.bool,
  showClose: PropTypes.bool,
  onBlur: PropTypes.func,
  onCloseClick: PropTypes.func,
  autoFocus: PropTypes.bool,
}

export default BuildingAutoComplete
